import React from 'react';
import Form from 'react-bootstrap/Form';
import i18n from 'i18n';

interface SearchBoxProps {
    placeholder?: string;
    value: string;
    onChange: (value: string) => void;
    className?: string;
}

const SearchBox: React.FC<SearchBoxProps> = ({
    placeholder = i18n.t('es_search.text'),
    value,
    onChange,
    className = 'mb-2'
}) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        onChange(event.target.value);
    };

    return (
        <Form
            className={`search-box ${className}`}
            onSubmit={(e: React.FormEvent) => {
                e.preventDefault();
            }}
        >
            <Form.Control
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
            />
        </Form>
    );
};

export default SearchBox;
